<app-form-element [control]="formControl" [id]="id" [label]="label" [required]="required" [twoColumns]="twoColumns">
  <p-select
    [appendTo]="'body'"
    [filter]="filter"
    [filterBy]="'label'"
    [formControl]="formControl"
    [id]="id"
    [options]="options"
    [placeholder]="placeholder ?? '' | translate"
    [style]="{ width: '100%' }"
    [virtualScroll]="virtualScroll()"
    [virtualScrollItemSize]="30"
    appScrollIntoView></p-select>
</app-form-element>
